if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (this.cart) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
                // Additive: lets analytics tell a quick-add from a product page add.
                addContext: this.closest('quick-add-modal') ? 'quick-add' : 'product-form',
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const ensureSections = () => {
              const hasSections =
                response?.sections &&
                this.cart
                  .getSectionsToRender()
                  .every((section) => Object.prototype.hasOwnProperty.call(response.sections, section.id));

              if (hasSections) return Promise.resolve(response);

              const sectionsToFetch = this.cart.getSectionsToRender().map((section) => section.id).join(',');
              const sectionsUrl = `${
                (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'
              }?sections=${sectionsToFetch}&sections_url=${encodeURIComponent(window.location.pathname)}`;

              return fetch(sectionsUrl)
                .then((res) => res.json())
                .then((sections) => {
                  response.sections = sections;
                  return response;
                })
                .catch(() => response);
            };

            const renderCartDrawer = () => {
              ensureSections().then(() => {
                CartPerformance.measure('add:paint-updated-sections', () => {
                  this.cart.renderContents(response);

                  // On mobile (<750px), show toast notification
                  if (window.innerWidth < 750) {
                    this.showMobileToast();
                  }
                });
              });
            };
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    renderCartDrawer();
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              renderCartDrawer();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      showMobileToast() {
        // Experiment-aware toast defined in layout/theme.liquid.
        if (typeof window.pipersMobileToast === 'function') {
          window.pipersMobileToast();
          return;
        }

        const toast = document.getElementById('mobile-cart-toast');
        if (!toast) return;

        // Clear any existing timeout
        if (this.toastTimeout) {
          clearTimeout(this.toastTimeout);
        }

        // Show toast
        toast.classList.add('active');

        // Auto-hide after 2.5 seconds
        this.toastTimeout = setTimeout(() => {
          toast.classList.remove('active');
        }, 2500);
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
